module.exports = __webpack_public_path__ + "media/honey-icons/icon-glass-breaking-1a64d66a.svg";